import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;

  label {
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    color: ${props => props.theme.colors.text.default};
  }

  div {
    display: flex;
    gap: ${props => props.theme.spacing.sp8};
    align-items: center;
    background-color: ${props => props.theme.colors.background.secondary};
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    color: ${props => props.theme.colors.outline.default};
    border-radius: ${props => props.theme.primitives.radius.radius1};
  }

  small {
    font-size: ${props => props.theme.texts.bodyXSRegular.fontSize};
    color: ${props => props.theme.colors.text.default};
    margin-left: ${props => props.theme.spacing.sp16};
  }
`
